module.exports = __webpack_public_path__ + "CW.png?cb93a9aa66a774d4a06780f560a6743b";